"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveClientSession = saveClientSession;
exports.loadClientSession = loadClientSession;
exports.clearClientSession = clearClientSession;
var CLIENT_STORAGE_KEY = "client";
function saveClientSession(client) {
    localStorage.setItem(CLIENT_STORAGE_KEY, JSON.stringify(client));
}
function loadClientSession() {
    var raw = localStorage.getItem(CLIENT_STORAGE_KEY);
    if (!raw)
        return null;
    try {
        return JSON.parse(raw);
    }
    catch (_a) {
        return null;
    }
}
function clearClientSession() {
    localStorage.removeItem(CLIENT_STORAGE_KEY);
}
